function pickFirst(...values) {
  return values.find((v) => v !== undefined && v !== null && String(v).trim() !== '');
}

function normalizePlans(payload) {
  if (Array.isArray(payload?.commissionPlans)) return payload.commissionPlans;
  if (payload?.commissionPlans && typeof payload.commissionPlans === 'object') return Object.values(payload.commissionPlans);
  if (Array.isArray(payload)) return payload;
  return [];
}

export function mapCommissionPlansResponseToDto(payload) {
  return normalizePlans(payload).map((plan, index) => ({
    key: String(pickFirst(plan.uid, `plan-${index}`)),
    uid: String(pickFirst(plan.uid) || '').trim(),
    name: pickFirst(plan.name) || '-',
    maxDepth: typeof plan.maxDepth === 'number' ? plan.maxDepth : 0,
    isDefault: Boolean(plan.isDefault),
    isActive: Boolean(plan.isActive),
    tierCount: Array.isArray(plan.tiers) ? plan.tiers.length : 0,
    created: pickFirst(plan.created, plan.createdAt, plan.created_at),
  }));
}
